import { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withOverlay } from "@dpdgroupuk/mydpd-ui";
import { compose } from "redux";
import { withAppContext } from "../../Context";
import { ROUTE } from "../../constants";
import { clearAppUserData } from "../../features/App/AppActions";
import { QueryUtil, EnvUtil } from "../../utils";

const Logout = ({
  signOut
}) => {
  useEffect(() => {
    signOut();
  }, []);
  return null;
};

Logout.propTypes = {
  signOut: PropTypes.func
};
export default compose(withOverlay, withAppContext, connect(null, (dispatch, {
  overlay,
  app,
  history
}) => ({
  signOut: overlay.showWhile(async () => {
    dispatch(clearAppUserData());
    await app.auth.logout();
    history.push({
      pathname: ROUTE.LOGON_PAGE,
      search: QueryUtil.stringifyQuery({
        carrier: EnvUtil.getBusinessIdFromOrigin(window.location)
      }, false)
    });
  })
})))(Logout);